<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: 0,
    },

    buttons: {
      type: [Array, Object],
      default: () => [],
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      curValue: this.value,
    };
  },

  computed: {
    normalizeButtons() {
      return _(this.buttons)
        .map((button) => {
          return _.isPlainObject(button)
            ? button
            : { text: button, value: button, icon: null };
        })
        .value();
    },
  },

  watch: {
    value(newValue) {
      this.curValue = newValue;
    },
  },

  methods: {
    updateValue(newValue) {
      if (this.disabled || newValue === this.curValue) {
        return;
      }

      this.curValue = newValue;
      this.$emit('select', newValue);
    },
  },
};
</script>
